// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loading-spinner-container[data-v-2f966590] {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 20px;
}
.loading-spinner[data-v-2f966590] {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin-2f966590 1s linear infinite;
}
@keyframes spin-2f966590 {
0% { transform: rotate(0deg);
}
100% { transform: rotate(360deg);
}
}
`, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner.vue"],"names":[],"mappings":";AAaA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;AACf;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2CAAkC;AACpC;AAEA;AACE,KAAK,uBAAuB;AAAE;AAC9B,OAAO,yBAAyB;AAAE;AACpC","sourcesContent":["<template>\n  <div class=\"loading-spinner-container\">\n    <div class=\"loading-spinner\"></div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'LoadingSpinner'\n};\n</script>\n\n<style scoped>\n.loading-spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
